angular.module('bmsApp.fees')
	.controller('OpenVisitsCtrl', [
		'$log',
		'$state',
		'$scope',
		'FeeSvc',
		'visits',
		'$modalInstance',
		'InstanceSvc',
		function ($log,
				  $state,
				  $scope,
				  FeeSvc,
				  visits,
				  $modalInstance,
				  InstanceSvc) {

			function init() {
				self.visits = visits;
			}

			function cancel() {
				$modalInstance.dismiss('cancel');
			}

			function viewCloseJobs() {
				// grab me the first visit and we'll extrapolate the to/from date from that
				let visit = self.visits[0];
				let visitDate;
				let startDate;
				let endDate;
				if (InstanceSvc.instance.isMM()) {
					visitDate = moment(visit.job_date);
					startDate = visitDate.clone().startOf('month');
					endDate = visitDate.clone().endOf('month');
				}
				else if (InstanceSvc.instance.isTG()) {
					visitDate = moment(visit.visit_date);
					startDate = visitDate.clone().startOf('month');
					endDate = visitDate.clone().endOf('month');
				}

				$modalInstance.close({
					data: {
						startDate: startDate.format(),
						endDate: endDate.format(),
					}
				});
			}

			var self = $scope.OpenVisitsCtrl = {
				visits: [],
				methods: {
					init: init,
					cancel: cancel,
					viewCloseJobs: viewCloseJobs
				}
			};

		}
	]);